import React, { useState, useCallback, useMemo } from "react";
import { management } from "@solimat/solimat-web-endpoint";

const BASE_URL = import.meta.env.VITE_REACT_APP_MANAGEMENT_PATH || "";
const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_MANAGEMENT_KEY || "";
const apiManagement = new management.ManagementService(BASE_URL, FUNCTIONS_KEY);

// Reutiliza la petición en curso entre instancias del hook y la libera al finalizar para permitir futuras recargas.
let getMyManagementInFlight: ReturnType<typeof apiManagement.getMyManagement> | null = null;

const requestMyManagement = () => {
  if (!getMyManagementInFlight) {
    const request = apiManagement.getMyManagement();
    getMyManagementInFlight = request;

    const clearRequest = () => {
      if (getMyManagementInFlight === request) {
        getMyManagementInFlight = null;
      }
    };

    request.then(clearRequest, clearRequest);
  }
  return getMyManagementInFlight;
};

function useGetMyManagement() {
  const BASE_URL = import.meta.env.VITE_REACT_APP_MANAGEMENT_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_MANAGEMENT_KEY || "";
  const apiManagement = useMemo(
    () => new management.ManagementService(BASE_URL, FUNCTIONS_KEY),
    [BASE_URL, FUNCTIONS_KEY],
  );
  const [loadinGetMyManagement, setLoadingGetMyManagement] = useState(false);
  const [successGetMyManagement, setSuccessGetMyManagement] = useState(false);
  const [errorGetMyManagement, setErrorGetMyManagement] = useState(null);
  const [dataMyManagement, setdataMyManagement] = useState({});
  const [activeManagements, setActiveManagements] = useState([]);
  const [groupsActiveManagements, setgroupsActiveManagements] = useState([]);
  const [groupsGeneralManagements, setgroupsGeneralManagements] = useState([]);
  const [generalManagements, setGeneralManagements] = useState([]);
  const [expedienteId, setExpedienteId] = useState<number | null>(null);
  const [formulariosAutorizaciones, setFormulariosAutorizaciones] = useState([]);
  const [documentosAutorizaciones, setDocumentosAutorizaciones] = useState([]);

  const getMyManagement = useCallback((_cb?: (data: any) => void) => {
    setLoadingGetMyManagement(true);
    setErrorGetMyManagement(null);
    setSuccessGetMyManagement(false);
    setdataMyManagement({});
    const promise = apiManagement.getMyManagement(); // cabiar para datos mock
    promise
      .then((res: any) => {
        setSuccessGetMyManagement(true);
        setActiveManagements(res.data.Activos?.Gestiones);
        setGeneralManagements(res.data.Generales?.Gestiones);
        setgroupsGeneralManagements(res.data.Generales?.Grupos);
        setgroupsActiveManagements(res.data.Activos?.Grupos);
        setExpedienteId(res.data?.ExpedienteId ?? null);
        setFormulariosAutorizaciones(res.data.Autorizaciones.FormulariosAutorizaciones);
        setDocumentosAutorizaciones(res.data.Autorizaciones.DocumentosAutorizaciones);
        setdataMyManagement(res.data && res.data);
        setLoadingGetMyManagement(false);
        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err) => {
        console.error("getCurrentRequestTransaction error: ", err);
        setErrorGetMyManagement(err);
        setLoadingGetMyManagement(false);
      });
  }, []);

  return {
    dataMyManagement,
    generalManagements,
    groupsGeneralManagements,
    activeManagements,
    groupsActiveManagements,
    expedienteId,
    getMyManagement,
    loadinGetMyManagement,
    successGetMyManagement,
    errorGetMyManagement,
    formulariosAutorizaciones,
    documentosAutorizaciones,
  };
}

export default useGetMyManagement;
